__webpack_require__.p = "https://matchcenter-api.24media.gr/static/b2e527a743ff45e263f7/";